import React from "react";
import { BaseComponent } from "../base/BaseComponent";
import { appDomain } from "../../domain/domain";
import { IExerciseSession } from "../../domain/exercise/IExerciseSession";
import { IQuestionRecord } from "../../domain/exercise/IQuestionRecord";
import { IExerciseProgress } from "../../domain/exercise/IExerciseProgress";
import { ExerciseQuestion } from "./ExerciseQuestion";
import { IExcercise } from "../../domain/exercise/IExcercise";


interface IExerciseComponentProps {
    exercise: IExcercise;
    onCancel: Function;
}

interface IExerciseComponentState {
    questions: IQuestionRecord[];
}

export class ExerciseComponent extends BaseComponent<IExerciseComponentProps, IExerciseComponentState> {
    private session: IExerciseSession | null;
    private isAnswer = false;
    private progress: IExerciseProgress;
    constructor(props: IExerciseComponentProps) {
        super(props);
        this.state = { questions: [] };
        this.session = null;
        this.progress = { progress: 0, done: 0, total: 0 };
    }
    componentDidMount() {
        super.componentDidMount();
        this.loadData();
    }
    async loadData() {
        if (!this.props.exercise.questions)
            return;

        this.session = appDomain.exerciseService.getExerciseSession(this.props.exercise.questions, this.props.exercise.buckets);
        this.next();
    }
    toggle() {
        // toggle question/answer
        this.isAnswer = !this.isAnswer;
        this.forceUpdate();
    }
    next() {
        if (!this.session)
            return;

        this.isAnswer = false;
        const question = appDomain.exerciseService.getNextQuestion(this.session);
        this.progress = appDomain.exerciseService.getProgress(this.session);
        if (this.mounted) {
            if (question) {
                this.setState({ questions: [question] });
            }
            this.forceUpdate();
        }
    }
    answer(correct: boolean) {
        if (!this.session)
            return;

        if (this.session.currentQuestion)
            appDomain.exerciseService.answerQuestion(this.session.currentQuestion, correct);

        this.next();
    }
    render() {
        const questions = this.state.questions;
        const progress = this.progress;
        const answerCorrect = () => this.answer(true);
        const answerWrong = () => this.answer(false);
        return (<div className="exercise">
            <button type="button" className="cancel" onClick={() => this.props.onCancel()}>Cancel</button>
            <div className="status">{this.props.exercise.title}, {Math.round(progress.progress * 100)}%, {progress.done} / {progress.total}</div>

            <div className="question-wrapper">
                <div className="question" onClick={() => this.toggle()}>
                {questions.map((q, i) => <ExerciseQuestion key={i} question={q.question} showAnswer={this.isAnswer}></ExerciseQuestion>)}
                </div>
            </div>

            {[0].map((_, i) => {
                if (this.isAnswer) {
                    return <div key={i}>
                        <button type="button" className="wrong" onClick={answerWrong}>Wrong</button>
                        <button type="button" className="correct" onClick={answerCorrect}>Correct</button>
                    </div>;
                }
                return <div key={i}></div>;
            })}
        </div>);
    }
}
